import type { QueryGrantRes, JoinCheckParams } from 'api/api-type'
import { joinCheck, getJoinInfo, grantQuery } from 'api/index'
import { hideCornerButtonMore } from 'common/biz/corner-button'
import bridge from '@/common/biz/bridge'
import { linkAuthorizationManagement } from '@/common/biz/link-authorization-management'
import { omega } from '@didi/driver-biz-sdk'
import { hideLoading, showLoading, showToast } from '@/common/ts/toast'
import store from '@didi/store'
import { NAME_MAP, INSURANCE_ID, PAGE_URL } from '@/common/biz/constants'
import { showPersonInfoModal } from '@/common/biz/person-info-modal'
import { env } from '@didi/utils'
import { ref, watch, Ref } from '@vue/composition-api'
import { Dialog } from 'cube-ui'

function useAdaptiveBottomHeight(): [Ref<{
  paddingBottom: string
}>, Ref<null>] {
  const footerStyle = ref({
    paddingBottom: '0px'
  })
  const btn = ref()
  watch(btn, () => {
    if (btn.value) {
      footerStyle.value.paddingBottom = btn.value.$el.clientHeight + 'px'
    }
  })
  return [footerStyle, btn]
}

function _linkAuthorizationManagement(res: QueryGrantRes) {
  linkAuthorizationManagement({
    jumpUrl: `${PAGE_URL}/index.html?entry=home&grant=true`,
    failJumpUrl: `${PAGE_URL}/index.html?entry=home&failGrant=true`,
    productLine: res.product_line
  })
  return Promise.reject(new Error(''))
}

function _queryGrantHandler(): Promise<true> {
  return grantQuery({ item_id: INSURANCE_ID }).then(res => {
    if (res.grant) {
      return Promise.resolve(true)
    } else {
      hideLoading()
      _linkAuthorizationManagement(res)
      return Promise.reject(new Error('no grant'))
    }
  })
}

function _joinCheckHandler(companyId: number, cityId: number): Promise<true> {
  const params: JoinCheckParams = { item_id: INSURANCE_ID, city_id: cityId, company_id: companyId }
  return joinCheck(params).then(res => {
    if (res.check_pass === 1) {
      return Promise.resolve(true)
    } else {
      // eslint-disable-next-line
      return Promise.reject({
        errmsg: res.rule_result?.content,
        isPopup: res?.rule_result?.is_popup
      })
    }
  })
}
function _getLinkHandler(companyId: number) {
  const params = {
    item_id: INSURANCE_ID,
    company_id: companyId,
    insurant_type: 1
  } as const
  return getJoinInfo(params).then(res => {
    hideLoading()
    if (res.link) {
      hideCornerButtonMore()
      if (env.isAndroid && companyId === 20001) {
        bridge.openPage({
          url: decodeURIComponent(res.link),
          browser: true
        })
      } else {
        window.location.href = decodeURIComponent(res.link)
      }
    } else {
      showToast('请稍后再试')
    }
  })
}

function limitDialog(text) {
  Dialog.$create({
    title: '提示',
    content: text,
    type: 'alert',
    confirmBtn: '我知道了'
  }).show()
}

let requesting = false
function join(companyId: number, cityId: number): void {
  if (requesting) return
  requesting = true

  omega.trackEvent('am_c_insure_medinsurland_join_ck')
  showPersonInfoModal(NAME_MAP[companyId]).then(() => {
    showLoading()
    return _queryGrantHandler()
  }).then(() => {
    return _joinCheckHandler(companyId, cityId)
  }).then(() => {
    return _getLinkHandler(companyId)
  }).catch((err) => {
    hideLoading()
    if (err.isPopup) {
      limitDialog(err.errmsg)
      return
    }
    if (['fail close', 'fail cancel', 'no grant'].includes(err.message)) return
    showToast('请稍后再试')
  }).finally(() => {
    requesting = false
  })
}
function grantHandler(companyId: number, cityId: number): void {
  if (store.get('link_auth') === 'true') {
    store.set('link_auth', 'false')
    showLoading()
    _queryGrantHandler()
      .then(() => {
        return _joinCheckHandler(companyId, cityId)
      }).then(() => {
        return _getLinkHandler(companyId)
      }).catch((err) => {
        hideLoading()
        if (err.isPopup) {
          limitDialog(err.errmsg)
          return
        }
        if (err.message === 'no grant') return
        showToast('请稍后再试')
        console.log(err)
      })
  }
}

export {
  useAdaptiveBottomHeight,
  join,
  grantHandler
}
